module.exports = __webpack_public_path__ + "static/media/cossen.4962fabc.png";